import interact from "interactjs";
import {
  getHexFromTextShadow,
  hexToRgba,
  rgbToHex,
  splitPx,
} from "../../../utils/helper";
import { CommonUtils } from "./CommonUtils";
import { CustomPOIClass } from "./CustomPOI";
import IconVisibleLine from "../../../assets/icons/icon_visible_line.svg";

export class CustomLogoClass {
  static LogoBorderStyle =
    "drop-shadow(white 1px 1px) drop-shadow(white 1px -1px) drop-shadow(white -1px 1px) drop-shadow(white -1px -1px)";
  static AddLogoToMap = async ({
    mapboxgl,
    map,
    mapDraw,
    coordinates,
    logo,
    lastClickButton,
    logoDefaultStyle,
    defaultLogoValue,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    setResetMap,
    createNewPolygon,
    updateAutoSave,
    resetAllOnceChanged,
    poiImageId,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    disableUserActions,
    poiWidth,
    markerRef,
  }) => {
    let newPOIWidth = poiWidth;
    const inputMarkerId = poiImageId
      ? poiImageId
      : "imageArea^" +
        String(coordinates.lng) +
        "^" +
        String(coordinates.lat) +
        "^" +
        logo;
    // Div element
    const divElement = document.createElement("div");
    divElement.id = inputMarkerId;
    const poiSettingLive = getCurrentPoiSetting();

    if (poiImageId) {
      divElement.style.width = "60px";
      // divElement.style.maxHeight = "60px";
    }
    // else {
    //     divElement.style.width = "300px"
    // }
    // Sub div element
    const divSubContainerElement = document.createElement("div");
    // divSubContainerElement.style.minWidth = "100%";
    // divSubContainerElement.style.minHeight = "100%";
    divSubContainerElement.id = inputMarkerId;
    // Sub div element
    const divSubElement = document.createElement("div");
    divSubElement.classList.add("logo-grid-item");
    divSubElement.id = inputMarkerId;

    // Create the Image element
    const logoImg = document.createElement("img");
    logoImg.className = "marker-image";
    // logoImg.width = "100px";
    logoImg.src = logo;
    logoImg.alt = "logo";
    logoImg.id = inputMarkerId;
    logoImg.style.backgroundColor = poiImageId
      ? poiSettingLive.poiBackgroundColor
      : "transparent";
    logoImg.style.objectFit = "contain";
    // Adding box style
    const haloEffectX = poiImageId
      ? poiSettingLive.poiHaloEffect_x
      : logoDefaultStyle.logoHaloEffect_x;
    const haloEffectY = poiImageId
      ? poiSettingLive.poiHaloEffect_y
      : logoDefaultStyle.logoHaloEffect_y;
    const haloEffectB = poiImageId
      ? poiSettingLive.poiHaloEffect_b
      : logoDefaultStyle.logoHaloEffect_b;
    const logoHaloEffect = poiImageId
      ? poiSettingLive.poiHaloEffect
      : logoDefaultStyle.logoHaloEffect;
    const leaderLineColor = poiImageId
      ? poiSettingLive.poiLeaderLineColor
      : logoDefaultStyle.logoLeaderLineColor;
    const leaderLineWidth = poiImageId
      ? poiSettingLive.poiLeaderLineBorderWidth
      : logoDefaultStyle.logoLeaderLineBorderWidth;

    logoImg.style.boxShadow = `${haloEffectX}px ${haloEffectY}px ${haloEffectB}px ${logoHaloEffect}`;
    if (poiImageId) {
      let width = poiSettingLive.poiWidthAndHeight;
      const getMeta = (url) =>
        new Promise((resolve, reject) => {
          const img = new Image();
          img.onload = () => resolve(img);
          img.onerror = (err) => reject(err);
          img.src = url;
        });
      await (async () => {
        const img = await getMeta(logo);
        if (img.naturalWidth) {
          if (img.naturalHeight >= img.naturalWidth - 40) {
            width = "41px";
            newPOIWidth = width;
          }
        }
      })();
      logoImg.dataset.width = width;
    } else {
      logoImg.dataset.width = newPOIWidth || "100px";
    }
    const isBackgroundTransparent = poiImageId
      ? poiSettingLive.poiBackgroundTransparent
      : logoDefaultStyle.isBackgroundColorTransparent;

    if (!isBackgroundTransparent) {
      if (
        (poiImageId && poiSettingLive.poiHaloEffectTransparent) ||
        (!poiImageId && logoDefaultStyle.logoHaloEffectTransparent)
      ) {
        logoImg.style.filter = `drop-shadow(${haloEffectX}px ${haloEffectY}px ${haloEffectB}px ${logoHaloEffect})`;
      }
      logoImg.style.filter = this.LogoBorderStyle;
      logoImg.style.boxShadow = "unset";
      logoImg.style.backgroundColor = "transparent";
    }

    // Adding box DataSet
    logoImg.dataset.backgroundColor = poiImageId
      ? poiSettingLive.poiBackgroundColor
      : logoDefaultStyle.logoBackgroundColor;
    logoImg.dataset.isBackgroundTransparent =
      logoDefaultStyle.isBackgroundColorTransparent ? "true" : "false";

    logoImg.dataset.logoHaloEffect_x = poiImageId
      ? String(poiSettingLive.poiHaloEffect_x)
      : String(logoDefaultStyle.logoHaloEffect_x);
    logoImg.dataset.logoHaloEffect_y = poiImageId
      ? String(poiSettingLive.poiHaloEffect_y)
      : String(logoDefaultStyle.logoHaloEffect_y);
    logoImg.dataset.logoHaloEffect_b = poiImageId
      ? String(poiSettingLive.poiHaloEffect_b)
      : String(logoDefaultStyle.logoHaloEffect_b);
    logoImg.dataset.logoHaloEffect = poiImageId
      ? poiSettingLive.poiHaloEffect
      : logoDefaultStyle.logoHaloEffect;
    logoImg.dataset.lng = String(coordinates.lng);
    logoImg.dataset.lat = String(coordinates.lat);
    logoImg.dataset.connectedLeaderLineWidth = String(
      logoDefaultStyle.logoLeaderLineBorderWidth
    );
    logoImg.dataset.connectedLeaderLineColor = String(
      logoDefaultStyle.logoLeaderLineColor
    );
    logoImg.dataset.leaderLineEnabled = "true";
    logoImg.dataset.lineConnected = inputMarkerId;
    // Appending child to main div
    divSubElement.appendChild(logoImg);
    divSubContainerElement.appendChild(divSubElement);
    divElement.appendChild(divSubContainerElement);
    divElement.style.width = newPOIWidth || "100px";

    const imageMarker = new mapboxgl.Marker({
      draggable: true,
      element: divElement,
      anchor: "top-left",
    })
      .setLngLat([coordinates.lng, coordinates.lat])
      .addTo(map);

    // Please uncomment the code when you are using leader line for the logo.
    createNewPolygon();
    await new Promise((resolve) => setTimeout(() => resolve(), 200));
    mapDraw = mapDraw.current || mapDraw;
    const lngLat = imageMarker.getLngLat();
    const feature = {
      id: inputMarkerId,
      type: "Feature",
      properties: {
        "line-color": poiImageId
          ? poiSettingLive.poiLeaderLineColor
          : logoDefaultStyle.logoLeaderLineColor,
        "line-width": poiImageId
          ? poiSettingLive.poiLeaderLineBorderWidth
          : logoDefaultStyle.logoLeaderLineBorderWidth,
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [lngLat.lng, lngLat.lat],
          [lngLat.lng, lngLat.lat],
        ],
      },
    };
    logoImg.dataset.leaderLine = JSON.stringify(feature);

    const featureIds = mapDraw.add(feature);
    mapDraw.changeMode("draw_line_string");
    currentMode.current = "direct_select";
    mapDraw.changeMode("simple_select");

    mapDraw.setFeatureProperty(featureIds[0], "line-color", leaderLineColor);
    mapDraw.setFeatureProperty(
      featureIds[0],
      "line-width",
      leaderLineWidth * 1
    );
    mapDraw.setFeatureProperty(featureIds[0], "vertexColor", leaderLineColor);

    CommonUtils.UpdateVertexColorLayer({
      featureId: featureIds[0],
      mapDraw,
      map,
      currentMode,
      polygonDefaultStyle,
    });
    function onDocumentMouseUp() {
      map.setLayoutProperty(
        featureIds[0] + "-end-point",
        "visibility",
        "visible"
      );
      document.removeEventListener("mouseup", onDocumentMouseUp);
    }
    map.on("mousedown", featureIds[0] + "-end-point", function () {
      map.setLayoutProperty(featureIds[0] + "-end-point", "visibility", "none");
      document.addEventListener("mouseup", onDocumentMouseUp);
    });
    map.on("draw.update", (e) => {
      const features = e.features;
      let updatedCoordinate;
      features.forEach((feature) => {
        if (
          feature.geometry.type === "LineString" &&
          feature.id === featureIds[0]
        ) {
          const coordinates = feature.geometry.coordinates;
          updatedCoordinate = coordinates[0];
          //const source = map.getSource(featureIds[0] + "-end-point");
          map.getSource(featureIds[0] + "-end-point")?.setData({
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: updatedCoordinate,
                },
              },
            ],
          });
        }
      });
    });
    map.getCanvas().style.cursor = "default";
    setMapToolBarOptionFlags((prev) => ({
      ...prev,
      logoUpload: false,
    }));
    setResetMap(false);
    if (!inputMarkerId) {
      setSelectedLogo({
        ...defaultLogoValue.current,
        openSetting: true,
        id: inputMarkerId,
        connectedLeaderLineId: logoImg.dataset.lineConnected,
        polyLineColor: logoDefaultStyle.logoLeaderLineColor,
        polyLineWidth: logoDefaultStyle.logoLeaderLineBorderWidth,
        imageBackgroundColor: logoDefaultStyle.logoBackgroundColor,
        logoHaloEffect: logoDefaultStyle.logoHaloEffect,
        image: logo,
        isBackgroundColorTransparent:
          logoDefaultStyle.isBackgroundColorTransparent,
        width: logoDefaultStyle.width,
        height: logoDefaultStyle.height,
        lat: logoImg.dataset.lat,
        lng: logoImg.dataset.lng,
      });
    }
    markerRef.current.push({
      id: inputMarkerId,
      marker: imageMarker,
      type: "logo",
    });
    updateAutoSave();

    logoImg.addEventListener("contextmenu", (event) => {
      event.preventDefault();
      if (disableUserActions?.()) {
        return;
      }
      currentMode.current = "direct_select";
      lastClickButton.current = 0;
      resetAllOnceChanged();
      this.GetLogoStyleWithLeaderLine({
        mapDraw,
        imageMarker,
        logoElement: logoImg,
        logoDefaultStyle,
        setSelectedLogo,
      });
    });

    if (poiImageId && poiSettingLive.showLeaderLine) {
      logoImg.dataset.leaderLineEnabled = poiSettingLive.showLeaderLine
        ? "true"
        : "false";
    } else {
      logoImg.dataset.leaderLineEnabled = poiImageId
        ? String(poiSettingLive.showLeaderLine)
        : "true";
    }

    CommonUtils.HideOrShowLeaderLine({
      mapDraw,
      connectedLeaderLine: inputMarkerId,
      correspondingElement: logoImg,
      leaderLine: {
        leaderLineColor: poiSettingLive.poiLeaderLineColor,
        leaderLineWidth: poiSettingLive.poiLeaderLineBorderWidth,
      },
      condition: !poiSettingLive.showLeaderLine,
      map,
    });

    this.AddLogoEventListener({
      map,
      mapDraw,
      mapboxgl,
      imageMarker,
      logoElement: logoImg,
      connectedLeaderLineId: logoImg.dataset.lineConnected,
      logoDefaultStyle,
      lastClickButton,
      defaultLogoValue,
      poiSetting: poiSettingLive,
      setSelectedLogo,
      setMapToolBarOptionFlags,
      updateAutoSave,
      setResetMap,
      createNewPolygon,
      resetAllOnceChanged,
      currentMode,
      polygonDefaultStyle,
      getCurrentPoiSetting,
      setDrawnFeaturesSupport,
      setUndoHistory,
      setRedoHistory,
      disableUserActions,
      markerRef,
    });
    //created Polygon history start
    setDrawnFeaturesSupport((previousValue) => {
      previousValue[inputMarkerId] = logoImg.cloneNode();
      return previousValue;
    });
  };

  static AddImageFromCluster = ({
    retailerCoordinates,
    imageSrc,
    logoId,
    map,
    mapDraw,
    mapboxgl,
    logoDefaultStyle,

    lastClickButton,
    defaultLogoValue,
    poiSetting,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    updateAutoSave,
    setResetMap,
    createNewPolygon,
    resetAllOnceChanged,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    markerRef,
  }) => {
    this.AddLogoToMap({
      mapboxgl,
      map,
      mapDraw,
      coordinates: retailerCoordinates,
      logo: imageSrc,
      lastClickButton,
      logoDefaultStyle,
      defaultLogoValue,
      setSelectedLogo,
      setMapToolBarOptionFlags,
      setResetMap,
      createNewPolygon,
      updateAutoSave,
      resetAllOnceChanged,
      poiImageId: logoId?.startsWith("poiImage^") ? logoId : null,
      currentMode,
      polygonDefaultStyle,
      getCurrentPoiSetting,
      setDrawnFeaturesSupport,
      setUndoHistory,
      setRedoHistory,
      markerRef,
    });
  };

  static GetLogoInteractionButtons = (isCluster) => {
    // Create the button element
    //const moveLogoButton = document.createElement("img");
    const moveLogoButton = document.createElement("i");
    moveLogoButton.style.color = "white";
    moveLogoButton.style.border = "0";
    moveLogoButton.style.borderRadius = "100%";
    moveLogoButton.style.cursor = "move";
    moveLogoButton.style.position = "absolute";
    moveLogoButton.style.left = "0px";
    moveLogoButton.style.top = isCluster ? "2px" : "-20px";
    moveLogoButton.style.fontSize = "18px";
    moveLogoButton.style.zIndex = "1";
    moveLogoButton.classList.add("fa-regular");
    moveLogoButton.classList.add("fa-arrows-maximize");
    moveLogoButton.id = "move-cluster-leader-line";

    // Create the button element
    const removeClusterLogoButton = document.createElement("i");
    removeClusterLogoButton.style.color = "white";
    removeClusterLogoButton.style.border = "0";
    removeClusterLogoButton.style.borderRadius = "100%";
    removeClusterLogoButton.style.cursor = "pointer";
    removeClusterLogoButton.style.position = "absolute";
    removeClusterLogoButton.style.right = "0px";
    removeClusterLogoButton.style.top = isCluster ? "0px" : "-20px";
    removeClusterLogoButton.style.fontSize = "18px";
    removeClusterLogoButton.style.zIndex = "1";
    removeClusterLogoButton.classList.add("fa-regular");
    removeClusterLogoButton.classList.add("fa-xmark");
    removeClusterLogoButton.id = "remove-cluster";

    // Create the move button element
    const hideLeaderLineButton = document.createElement("img");
    hideLeaderLineButton.style.backgroundColor = "white";
    hideLeaderLineButton.style.border = "0";
    hideLeaderLineButton.style.borderRadius = "100%";
    hideLeaderLineButton.style.cursor = "not-allowed";
    hideLeaderLineButton.style.position = "absolute";
    hideLeaderLineButton.style.left = "22px";
    hideLeaderLineButton.style.top = "-20px";
    hideLeaderLineButton.style.height = "18px";
    hideLeaderLineButton.style.zIndex = "1";
    hideLeaderLineButton.src = `${IconVisibleLine}`;
    return {
      move: moveLogoButton,
      hide: hideLeaderLineButton,
      remove: removeClusterLogoButton,
    };
  };

  static GetLogoStyleWithLeaderLine = ({
    mapDraw,
    imageMarker,
    logoElement,
    logoDefaultStyle,
    setSelectedLogo,
  }) => {
    let backGroundColor = logoElement.dataset.backgroundColor;
    let isBackGroundColorTransparent = true;
    mapDraw = mapDraw.current || mapDraw;
    let feature = mapDraw.get(logoElement.dataset.lineConnected);
    let leaderLineEnabled = true;
    const markerElement = imageMarker.getElement();
    const isLeaderLineDisabled =
      markerElement &&
      markerElement.dataset &&
      ((markerElement.dataset.cluster === "true" &&
        logoElement &&
        logoElement.id === markerElement.id) ||
        markerElement.dataset.cluster !== "true");
    if (
      !feature &&
      logoElement.dataset &&
      logoElement.dataset.leaderLine &&
      logoElement.dataset.leaderLineEnabled
    ) {
      feature = JSON.parse(logoElement.dataset.leaderLine);
      leaderLineEnabled = false;
    } else if (
      !logoElement.dataset ||
      (logoElement.dataset && !logoElement.dataset.leaderLineEnabled)
    ) {
      leaderLineEnabled = false;
    }
    const haloEffect = {
      logoHaloEffectX: logoDefaultStyle.logoHaloEffect_x,
      logoHaloEffectY: logoDefaultStyle.logoHaloEffect_y,
      logoHaloEffectB: logoDefaultStyle.logoHaloEffect_b,
      logoHaloEffectC: logoDefaultStyle.logoHaloEffect_c,
      logoHaloEffectColor: logoDefaultStyle.logoHaloEffect,
      logoHaloEffect: Boolean(logoDefaultStyle.logoHaloEffectTransparent),
    };

    if (
      logoElement.style.boxShadow === "unset" &&
      logoElement.style.filter === "unset" &&
      logoElement.dataset.boxShadow
    ) {
      const colorSplit = logoElement.dataset.boxShadow.split(/\s+/);
      haloEffect.logoHaloEffectX = splitPx(colorSplit[0])[0];
      haloEffect.logoHaloEffectY = splitPx(colorSplit[1])[0];
      haloEffect.logoHaloEffectB = splitPx(colorSplit[2])[0];
      haloEffect.logoHaloEffectC = splitPx(colorSplit[2])[0];
      haloEffect.logoHaloEffectColor = colorSplit[3];
      haloEffect.logoHaloEffect = false;
    } else if (logoElement.style.filter !== this.LogoBorderStyle) {
      let splitArray;
      if (logoElement.style.boxShadow === "unset") {
        const regex = /rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|-?\d*\.?\d+px/g;
        splitArray = logoElement.style.filter.match(regex);
      } else {
        const regex = /rgb\(\d{1,3}, \d{1,3}, \d{1,3}\)|-?\d*\.?\d+px/g;
        splitArray = logoElement.style.boxShadow.match(regex);
      }
      if (splitArray) {
        haloEffect.logoHaloEffectColor = getHexFromTextShadow(
          splitArray[0],
          "color"
        );
        haloEffect.logoHaloEffectX = splitPx(splitArray[1])[0];
        haloEffect.logoHaloEffectY = splitPx(splitArray[2])[0];
        haloEffect.logoHaloEffectB = splitPx(splitArray[3])[0];
        haloEffect.logoHaloEffectC = splitPx(splitArray[3])[0];
      }
      haloEffect.logoHaloEffect = logoDefaultStyle.logoHaloEffectTransparent;
    }
    if (
      logoElement.style &&
      logoElement.style.backgroundColor &&
      logoElement.style.backgroundColor !== "" &&
      logoElement.style.backgroundColor !== "transparent"
    ) {
      backGroundColor = rgbToHex(logoElement.style.backgroundColor);
      isBackGroundColorTransparent = false;
    }
    // Please uncomment the code when you are using the drag icon for dragging the logo.
    // let imageUrl = ""
    // const imgElements = markerElement.querySelectorAll("img");
    // if (imgElements && imgElements.length >= 3) {
    //     const logoElement = imgElements[2];
    //     imageUrl = logoElement.src;
    // }

    setSelectedLogo(() => ({
      id: logoElement.id,
      connectedLeaderLineId: logoElement.dataset.lineConnected,
      openSetting: true,
      resetLogoSettings: true,
      polyLineColor:
        feature && feature.properties["line-color"]
          ? feature.properties["line-color"]
          : logoDefaultStyle.logoLeaderLineColor,
      polyLineWidth:
        feature && feature.properties["line-width"]
          ? feature.properties["line-width"]
          : logoDefaultStyle.logoLeaderLineBorderWidth,
      imageBackgroundColor: backGroundColor,
      isBackgroundColorTransparent: isBackGroundColorTransparent,
      image: logoElement.innerHTML,
      logoHaloEffect: haloEffect.logoHaloEffectColor,
      logoHaloEffect_x: haloEffect.logoHaloEffectX,
      logoHaloEffect_y: haloEffect.logoHaloEffectY,
      logoHaloEffect_b: haloEffect.logoHaloEffectB,
      logoHaloEffect_c: haloEffect.logoHaloEffectB,
      isHaloEffectTransparent: haloEffect.logoHaloEffect,
      isLeaderLineEnabled: leaderLineEnabled,
      isLeaderLineDisabled: !isLeaderLineDisabled,
      width: logoElement.dataset.width,
      height: logoElement.style.height,
      lat: String(logoElement.dataset.lat),
      lng: String(logoElement.dataset.lng),
    }));
  };

  static OnMoveLogo = ({
    coordinates,
    connectedLeaderLine,
    mapDraw,
    connectedLeaderLineWidth,
    imageElement,
    logoDefaultStyle,
    map,
    isUpdate = false,
    allCoordinates,
  }) => {
    //const lineConnected = mapDraw.get(connectedLeaderLine);
    imageElement.dataset.modified = "true";
    const lineConnected = CommonUtils.HideOrShowLeaderLine({
      mapDraw,
      connectedLeaderLine,
      correspondingElement: imageElement,
      leaderLine: {
        leaderLineColor: logoDefaultStyle.logoLeaderLineColor,
        leaderLineWidth: logoDefaultStyle.logoLeaderLineBorderWidth,
      },
      condition: false,
      map,
    });
    let changedCoordinates;
    if (!isUpdate) {
      changedCoordinates = [...lineConnected.geometry.coordinates];
      changedCoordinates.pop();
      changedCoordinates.push([coordinates.lng, coordinates.lat]);
      lineConnected.geometry.coordinates = changedCoordinates;
    } else {
      lineConnected.geometry.coordinates = allCoordinates;
      changedCoordinates = lineConnected;
    }
    if (
      imageElement.dataset.leaderLineEnabled &&
      imageElement.dataset.leaderLineEnabled === "true"
    ) {
      const source = map.getSource(connectedLeaderLine + "-end-point");
      if (!source) {
        const icon = {
          type: "Feature",
          geometry: {
            type: "Point",
            coordinates: lineConnected.geometry.coordinates[0],
          },
        };
        map.addSource(connectedLeaderLine + "-end-point", {
          type: "geojson",
          data: icon,
        });
        map.addLayer({
          id: connectedLeaderLine + "-end-point",
          type: "circle",
          source: connectedLeaderLine + "-end-point",
          paint: {
            "circle-radius": 6,
            "circle-color": lineConnected.properties["line-color"],
          },
        });
      }
      mapDraw.setFeatureProperty(
        connectedLeaderLine,
        "coordinates",
        changedCoordinates
      );
      mapDraw.add(lineConnected);
    }
    imageElement.dataset.leaderLine = JSON.stringify(lineConnected);
  };

  static updatePreviousValueChange = ({
    action,
    setDrawnFeaturesSupport,
    inputMarkerId,
    image,
    setSelectedLogo,
    setUndoHistory,
    setRedoHistory,
  }) => {
    setDrawnFeaturesSupport((previousValue) => {
      const preValue = previousValue[inputMarkerId];
      previousValue[inputMarkerId] = image.cloneNode();
      // Update the undo array
      const updateLogo = {
        action: "updated",
        type: "logo",
        id: inputMarkerId,
        previousValue: preValue,
        currentValue: image.cloneNode(),
      };
      setUndoHistory((previousValue) => {
        if (previousValue && previousValue.length >= 5) {
          previousValue.shift();
        }
        previousValue.push(updateLogo);
        return previousValue;
      });
      if (action !== "move") {
        setSelectedLogo((prev) => ({
          ...prev,
          width: image.dataset.width,
          height: image.style.height,
          resetLogoSettings: true,
        }));
      }
      setRedoHistory([]);
      return previousValue;
    });
  };

  static ClusterOutAllImagesInside = ({
    marker,
    map,
    mapDraw,
    mapboxgl,
    logoDefaultStyle,

    lastClickButton,
    defaultLogoValue,
    poiSetting,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    updateAutoSave,
    setResetMap,
    createNewPolygon,
    resetAllOnceChanged,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    markerRef,
  }) => {
    setSelectedLogo(null);
    const currentMarker = marker.getElement().cloneNode(true);
    markerRef.current = markerRef.current.filter(
      (marker) => marker.id !== currentMarker.id
    );
    const divElement = currentMarker.querySelector("div");
    const divElementToBeAppend = divElement.querySelectorAll("div");
    divElementToBeAppend.forEach((element) => {
      const logoElementToBeAppend = element.querySelector("img");
      const markerId = logoElementToBeAppend.id.split("^");
      const retailerCoordinates = {
        lng: parseFloat(markerId[1]),
        lat: parseFloat(markerId[2]),
      };
      this.AddImageFromCluster({
        retailerCoordinates,
        imageSrc: logoElementToBeAppend.src,
        logoId: logoElementToBeAppend.id,
        map,
        mapDraw,
        mapboxgl,
        logoDefaultStyle,
        lastClickButton,
        defaultLogoValue,
        poiSetting,
        setSelectedLogo,
        setMapToolBarOptionFlags,
        updateAutoSave,
        setResetMap,
        createNewPolygon,
        resetAllOnceChanged,
        currentMode,
        polygonDefaultStyle,
        getCurrentPoiSetting,
        setDrawnFeaturesSupport,
        setUndoHistory,
        setRedoHistory,
        markerRef,
      });
    });
    marker.remove();
    const vertexPoint = map.getLayer(currentMarker.id + "-end-point");
    if (vertexPoint) {
      map.removeLayer(currentMarker.id + "-end-point");
      map.removeSource(currentMarker.id + "-end-point");
    }
  };

  static AddClusterLogoEventListener = ({
    currenMarker,
    subElement,
    map,
    mapDraw,
    mapboxgl,
    logoDefaultStyle,
    disableUserActions,
    lastClickButton,
    defaultLogoValue,
    poiSetting,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    updateAutoSave,
    setResetMap,
    createNewPolygon,
    resetAllOnceChanged,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    markerRef,
  }) => {
    // Check for mouse event for textarea
    subElement.addEventListener("mousedown", function (event) {
      if (disableUserActions?.()) {
        return;
      }
      currenMarker.setDraggable(false);
      map.dragPan.disable();
    });

    subElement.addEventListener("mouseleave", function (event) {
      if (disableUserActions?.()) {
        return;
      }
      map.dragPan.enable();
      currenMarker.setDraggable(true);
    });

    const logoImg = subElement.querySelector("img");
    logoImg.addEventListener("contextmenu", (event) => {
      event.preventDefault();
      currentMode.current = "direct_select";
      lastClickButton.current = 0;
      resetAllOnceChanged();
      this.GetLogoStyleWithLeaderLine({
        mapDraw,
        imageMarker: currenMarker,
        logoElement: logoImg,
        logoDefaultStyle,
        setSelectedLogo,
      });
    });

    const intractableLogo = interact(subElement).draggable({
      inertia: true,
      modifiers: [
        interact.modifiers.restrictRect({
          restriction: "parent",
          endOnly: true,
        }),
      ],
      autoScroll: false,
      listeners: {
        move(event) {
          const target = event.target;
          const x = (parseFloat(target.getAttribute("data-x")) || 0) + event.dx;
          const y = (parseFloat(target.getAttribute("data-y")) || 0) + event.dy;
          target.style.transform = "translate(" + x + "px, " + y + "px)";
          target.setAttribute("data-x", x);
          target.setAttribute("data-y", y);
          const draggedElement = currenMarker.getElement();
          const draggedRect = draggedElement.getBoundingClientRect();
          const existingRect = subElement.getBoundingClientRect();

          // Check if the bounding boxes of the two elements intersect
          const isOverlapping =
            draggedRect.right < existingRect.left ||
            draggedRect.left > existingRect.right ||
            draggedRect.bottom < existingRect.top ||
            draggedRect.top > existingRect.bottom;

          if (isOverlapping && draggedElement.id !== subElement.id) {
            setSelectedLogo(null);
            intractableLogo.unset();
            const rawLogoId = subElement.id;
            const newLogoElementToBeAdded =
              subElement.firstChild.cloneNode(true);
            subElement.remove();
            newLogoElementToBeAdded.id = rawLogoId;
            const changedMarker = markerRef.current.map((marker) => {
              if (
                draggedElement.id === marker.id &&
                marker.idList &&
                marker.idList.includes(rawLogoId)
              ) {
                marker.idList = marker.idList.filter(
                  (logoElementId) => logoElementId !== rawLogoId
                );
                if (marker.idList.length === 1) {
                  const clonedMarkerDiv = marker.marker.getElement();
                  const clonedSubDivElement = clonedMarkerDiv
                    .querySelector("div")
                    .cloneNode(true);
                  const clonedSubDivSpan =
                    clonedMarkerDiv.querySelector("span");
                  clonedSubDivSpan?.remove();
                  const SubDivElement = clonedMarkerDiv.querySelector("div");
                  SubDivElement.remove();

                  const clonedSubDivContainer =
                    clonedSubDivElement.querySelector("div");
                  const logoImg = clonedSubDivElement.querySelector("img");

                  clonedMarkerDiv.dataset.cluster = "false";
                  clonedMarkerDiv.style.width = poiSetting.poiWidthAndHeight;
                  clonedMarkerDiv.style.height = "auto";
                  clonedSubDivElement.className = "";
                  clonedSubDivElement.style.width = "unset";
                  clonedSubDivElement.style.height = "unset";
                  clonedSubDivContainer.style.width = "100%";
                  clonedSubDivContainer.style.height = "100%";
                  clonedMarkerDiv.appendChild(clonedSubDivElement);

                  logoImg.addEventListener("contextmenu", (event) => {
                    //if (disableUserActions()) return;
                    event.preventDefault();
                    lastClickButton.current = 0;
                    resetAllOnceChanged();
                    CustomLogoClass.GetLogoStyleWithLeaderLine({
                      mapDraw,
                      imageMarker: marker.marker,
                      logoElement: logoImg,
                      logoDefaultStyle,
                      setSelectedLogo,
                    });
                  });

                  CustomLogoClass.AddLogoEventListener({
                    map,
                    mapDraw,
                    mapboxgl,
                    imageMarker: marker.marker,
                    logoElement: logoImg,
                    connectedLeaderLineId: logoImg.id,
                    logoDefaultStyle,
                    lastClickButton,
                    defaultLogoValue,
                    poiSetting,
                    setSelectedLogo,
                    setMapToolBarOptionFlags,
                    updateAutoSave,
                    setResetMap,
                    createNewPolygon,
                    resetAllOnceChanged,
                    currentMode,
                    polygonDefaultStyle,
                    getCurrentPoiSetting,
                    setDrawnFeaturesSupport,
                    setUndoHistory,
                    setRedoHistory,
                    markerRef,
                  });
                }
              }
              return marker;
            });
            markerRef.current = changedMarker;

            const markerId = rawLogoId.split("^");
            const retailerCoordinates = {
              lng: parseFloat(markerId[1]),
              lat: parseFloat(markerId[2]),
            };
            CustomLogoClass.AddImageFromCluster({
              retailerCoordinates,
              imageSrc: newLogoElementToBeAdded.src,
              logoId: rawLogoId,
              map,
              mapDraw,
              mapboxgl,
              logoDefaultStyle,
              lastClickButton,
              defaultLogoValue,
              poiSetting,
              setSelectedLogo,
              setMapToolBarOptionFlags,
              updateAutoSave,
              setResetMap,
              createNewPolygon,
              resetAllOnceChanged,
              currentMode,
              polygonDefaultStyle,
              getCurrentPoiSetting,
              setDrawnFeaturesSupport,
              setUndoHistory,
              setRedoHistory,
              markerRef,
            });
          }
        },
        end(event) {
          const target = event.target;
          subElement.style.transform = "unset";
          target.setAttribute("data-x", 0);
          target.setAttribute("data-y", 0);

          const overlapElement = document.elementFromPoint(
            event.client.x,
            event.client.y
          );
          const targetItem = overlapElement?.closest(".logo-grid-item");

          if (targetItem && targetItem !== subElement) {
            // Get the parent container (assuming .logo-grid is the container)
            const draggedElement = currenMarker.getElement();
            const draggedContainerElement = draggedElement.querySelector("div");

            const items = Array.from(
              draggedElement.querySelectorAll(".logo-grid-item")
            );

            // Get the indices of the target and dragged elements
            const draggedIndex = items.indexOf(target);
            const targetIndex = items.indexOf(targetItem);
            if (draggedIndex > -1 && targetIndex > -1) {
              const [draggedElementToMove] = items.splice(draggedIndex, 1); // Remove dragged element
              items.splice(targetIndex, 0, draggedElementToMove); // Insert it at the new position

              // Clear the container and re-insert elements in the new order
              draggedContainerElement.innerHTML = "";
              items.forEach((item) =>
                draggedContainerElement.appendChild(item)
              );
            }
          }

          map.dragPan.enable();
          currenMarker.setDraggable(true);
        },
      },
    });
  };

  static AddLogoEventListener = ({
    map,
    mapDraw,
    mapboxgl,
    imageMarker,
    logoElement,
    connectedLeaderLineId,
    logoDefaultStyle,

    lastClickButton,
    defaultLogoValue,
    poiSetting,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    updateAutoSave,
    setResetMap,
    createNewPolygon,
    resetAllOnceChanged,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    disableUserActions,
    isEmoji,
    markerRef,
  }) => {
    const inputMarkerId = logoElement.id;
    const markerElement = imageMarker.getElement();

    markerElement.addEventListener("mouseleave", function (event) {
      event.preventDefault();
      if (disableUserActions?.()) {
        return;
      }
      imageMarker.setDraggable(true);
      if (
        markerElement.dataset &&
        (!markerElement.dataset.cluster ||
          (markerElement.dataset.cluster &&
            markerElement.dataset.cluster === "false"))
      ) {
        markerElement.classList.remove("dragging");
      }
    });
    let updatedCoordinate;
    map.on("draw.update", (e) => {
      const features = e.features;
      features.forEach((feature) => {
        if (feature.geometry.type === "LineString") {
          function onDocumentMouseUp() {
            map.setLayoutProperty(
              feature.id + "-end-point",
              "visibility",
              "visible"
            );
            document.removeEventListener("mouseup", onDocumentMouseUp);
          }
          map.on("mousedown", feature.id + "-end-point", function () {
            map.setLayoutProperty(
              feature.id + "-end-point",
              "visibility",
              "none"
            );
            document.addEventListener("mouseup", onDocumentMouseUp);
          });
          const coordinates = feature.geometry.coordinates;
          updatedCoordinate = coordinates[0];
          map.getSource(feature.id + "-end-point")?.setData({
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: updatedCoordinate,
                },
              },
            ],
          });
        }
      });
    });

    // Use interactjs to make the area resizable
    interact(markerElement).resizable({
      edges: {
        left: false,
        right: true,
        bottom: true,
        top: false,
      },
      listeners: {
        move(event) {
          map.dragPan.disable();
          const target = event.target;
          if (!event.edges.right) {
            return; // Skip if not resizing from the bottom-right corner
          }
          if (disableUserActions?.()) {
            return;
          }
          if (isEmoji) {
            if (event.rect.width > 20) {
              logoElement.style.fontSize = event.rect.width + "px";
            }
            target.style.width = "auto";
          } else {
            if (event.rect.width > 40) {
              target.style.width = event.rect.width + "px";
              if (markerElement.getAttribute("data-cluster")) {
                target.style.height = event.rect.height + "px";
              }
            }
          }
        },
        end(event) {
          map.dragPan.enable();
          if (!event.edges.right) {
            return; // Skip if not resizing from the bottom-right corner
          }
          const clusterValue = markerElement.getAttribute("data-cluster");
          if (!isEmoji && !clusterValue) {
            logoElement.dataset.width = markerElement.style.width;
            // logoElement.dataset.height = markerElement.style.height;
            CustomLogoClass.updatePreviousValueChange({
              action: "update",
              setDrawnFeaturesSupport,
              inputMarkerId: logoElement.id,
              image: logoElement,
              setSelectedLogo,
              setUndoHistory,
              setRedoHistory,
            });
          }
        },
      },
      modifiers: [
        interact.modifiers.restrictEdges({
          outer: "parent",
          endOnly: true,
          enabled: false,
        }),
      ],
      inertia: true,
    });

    markerElement.addEventListener("mouseenter", function () {
      if (disableUserActions?.()) {
        return;
      }
      if (
        markerElement.dataset &&
        (!markerElement.dataset.cluster ||
          (markerElement.dataset.cluster &&
            markerElement.dataset.cluster === "false"))
      ) {
        markerElement.classList.add("dragging");
      }
    });

    // Check for mouse event
    markerElement.addEventListener("mousedown", function (event) {
      if (disableUserActions?.()) {
        return;
      }
      const logoRect = imageMarker.getElement().getBoundingClientRect();
      const offsetX = event.clientX - logoRect.right;
      // const offsetY = event.clientY - logoRect.bottom;
      const threshold = 27; // Adjust this value as needed
      const isRightEdge = Math.abs(offsetX) <= threshold;
      if (isRightEdge) {
        imageMarker.setDraggable(false);
        // setTimeout(() => {
        //   map.dragPan.disable();
        // }, 10);
      }
    });

    markerElement.addEventListener("mousemove", function (event) {
      if (disableUserActions?.()) {
        return;
      }
      const rect = markerElement.getBoundingClientRect();
      const mouseX = event.clientX;
      const mouseY = event.clientY;
      // Define a threshold distance from the edges, e.g., 10 pixels
      const threshold = 20;
      const isNearRight =
        mouseX > rect.right - threshold && mouseX < rect.right;
      const isNearBottomRight =
        isNearRight && mouseY > rect.bottom - threshold && mouseY < rect.bottom;

      if (!isNearBottomRight) {
        markerElement.style.cursor = "grab";
      }
    });

    markerElement.addEventListener("mouseleave", function (event) {
      if (disableUserActions?.()) {
        return;
      }
      map.dragPan.enable();
      imageMarker.setDraggable(true);
    });

    // Event listener for drag event to update the polyline dynamically
    imageMarker.on("drag", (event) => {
      if (disableUserActions?.()) {
        return;
      }

      this.OnMoveLogo({
        coordinates: {
          lng: event.target._lngLat.lng,
          lat: event.target._lngLat.lat,
        },
        connectedLeaderLine: connectedLeaderLineId,
        mapDraw,
        connectedLeaderLineWidth: parseInt(
          logoElement.dataset.connectedLeaderLineWidth
        ),
        imageElement: logoElement,
        logoDefaultStyle,
        map,
      });
    });

    // Inside the AddLogoEventListener function, modify the 'dragend' event listener
    imageMarker.on("dragend", (event) => {
      imageMarker.setDraggable(true);
      logoElement.dataset.lat = event.target._lngLat.lat;
      logoElement.dataset.lng = event.target._lngLat.lng;
      const clusterValue = markerElement.getAttribute("data-cluster");

      if (disableUserActions?.()) {
        return;
      }
      // Commented this code because the leader line was not removing on some cases
      this.OnMoveLogo({
        coordinates: {
          lng: event.target._lngLat.lng,
          lat: event.target._lngLat.lat,
        },
        connectedLeaderLine: connectedLeaderLineId,
        mapDraw,
        connectedLeaderLineWidth: parseInt(
          logoElement.dataset.connectedLeaderLineWidth
        ),
        imageElement: logoElement,
        logoDefaultStyle,
        map,
      });
      if (!clusterValue && !isEmoji) {
        this.updatePreviousValueChange({
          action: "move",
          setDrawnFeaturesSupport,
          inputMarkerId: logoElement.id,
          image: logoElement,
          setSelectedLogo,
          setUndoHistory,
          setRedoHistory,
        });
      }
      if (!isEmoji) {
        const draggedElement = imageMarker.getElement();
        const draggedRect = draggedElement.getBoundingClientRect();
        const checkCluster = draggedElement?.dataset?.cluster;
        const emoji = draggedElement?.dataset?.emoji;
        if (
          (checkCluster && checkCluster === "true") ||
          (emoji && emoji === "true")
        ) {
          return true;
        }
        let updatedMarkers = markerRef.current;
        for (const markerData of markerRef.current) {
          const existingElement = markerData.marker.getElement();
          const existingRect = existingElement.getBoundingClientRect();
          const emoji = existingElement?.dataset?.emoji;
          // Check if the bounding boxes of the two elements intersect
          // const isOverlapping = !(
          //   draggedRect.right < existingRect.left ||
          //   draggedRect.left > existingRect.right ||
          //   draggedRect.bottom < existingRect.top ||
          //   draggedRect.top > existingRect.bottom
          // );
          // if (
          //   isOverlapping &&
          //   markerData.id &&
          //   inputMarkerId !== markerData.id &&
          //   (markerData.id.startsWith("poiImage^") ||
          //     markerData.id.startsWith("imageArea^")) &&
          //   !emoji
          // ) {
          //   setTimeout(() => {
          //     setUndoHistory([]);
          //     setRedoHistory([]);
          //   }, 500);
          //   setSelectedLogo(null);
          //   const logoElementIds = [];
          //   const mapClusterInterActionFunction =
          //     this.GetLogoInteractionButtons(true);
          //   const previousLogoElementToBe = existingElement
          //     .querySelector("div")
          //     ?.cloneNode(true);
          //   const previousLogoElementToBeAppend =
          //     previousLogoElementToBe.querySelectorAll("div");
          //   const logoElementToBe = draggedElement.querySelector("div");
          //   const logoElementToBeAppend =
          //     logoElementToBe.querySelectorAll("div");
          //   existingElement.innerHTML = "";
          //   // existingElement.style.width = "auto";
          //   // existingElement.style.height = "auto";
          //   const checkClusterHasClusterControlTag =
          //     existingElement.querySelector("#move-cluster-leader-line");
          //   if (!checkClusterHasClusterControlTag) {
          //     const headerIconsDiv = CustomPOIClass.GetClusterHeaderIcons();
          //     existingElement.appendChild(headerIconsDiv);

          //     headerIconsDiv.append(mapClusterInterActionFunction.move);
          //     headerIconsDiv.append(mapClusterInterActionFunction.remove);
          //     existingElement.appendChild(headerIconsDiv);
          //     mapClusterInterActionFunction.remove.addEventListener(
          //       "mousedown",
          //       function () {
          //         CustomLogoClass.ClusterOutAllImagesInside({
          //           marker: markerData.marker,
          //           map,
          //           mapDraw,
          //           mapboxgl,
          //           logoDefaultStyle,
          //           lastClickButton,
          //           defaultLogoValue,
          //           poiSetting,
          //           setSelectedLogo,
          //           setMapToolBarOptionFlags,
          //           updateAutoSave,
          //           setResetMap,
          //           createNewPolygon,
          //           resetAllOnceChanged,
          //           currentMode,
          //           polygonDefaultStyle,
          //           getCurrentPoiSetting,
          //           setDrawnFeaturesSupport,
          //           setUndoHistory,
          //           setRedoHistory,
          //           markerRef,
          //         });
          //       }
          //     );
          //   }
          //   previousLogoElementToBe.classList.add("logo-grid-container");
          //   previousLogoElementToBe.classList.add("scrollbar-lg");
          //   existingElement.dataset.cluster = "true";
          //   existingElement.appendChild(previousLogoElementToBe);
          //   existingElement.classList.remove("dragging");
          //   imageMarker.remove();
          //   mapDraw.delete(inputMarkerId);
          //   const vertexPoint = map.getLayer(draggedElement.id + "-end-point");
          //   if (vertexPoint) {
          //     map.removeLayer(draggedElement.id + "-end-point");
          //     map.removeSource(draggedElement.id + "-end-point");
          //   }
          //   // Update the markers array
          //   updatedMarkers = markerRef.current.filter((marker) => {
          //     if (marker.id === inputMarkerId) {
          //       return false;
          //     }
          //     if (marker.id === markerData.id) {
          //       marker.idList = [...(marker.idList ?? []), ...logoElementIds];
          //       marker.idList = [...new Set(marker.idList)];
          //     }
          //     return true;
          //   });
          //   break;
          // }
          updateAutoSave();
        }
        markerRef.current = updatedMarkers;
      }
    });
  };

  static GetEmojiStyleWithLeaderLine = ({
    mapDraw,
    imageMarker,
    iTag,
    logoDefaultStyle,
    setSelectedLogo,
  }) => {
    let backGroundColor = iTag.dataset.backgroundColor;
    let isBackGroundColorTransparent = true;
    let feature = mapDraw.get(iTag.dataset.lineConnected);
    let leaderLineEnabled = true;
    const markerElement = imageMarker.getElement();

    const isLeaderLineDisabled =
      markerElement &&
      markerElement.dataset &&
      ((markerElement.dataset.cluster === "true" &&
        iTag &&
        iTag.id === markerElement.id) ||
        markerElement.dataset.cluster !== "true");
    if (
      !feature &&
      iTag.dataset &&
      iTag.dataset.leaderLine &&
      iTag.dataset.leaderLineEnabled
    ) {
      feature = JSON.parse(iTag.dataset.leaderLine);
      leaderLineEnabled = false;
    } else if (
      !iTag.dataset ||
      (iTag.dataset && !iTag.dataset.leaderLineEnabled)
    ) {
      leaderLineEnabled = false;
    }
    const haloEffect = {
      logoHaloEffectX: logoDefaultStyle.logoHaloEffect_x,
      logoHaloEffectY: logoDefaultStyle.logoHaloEffect_y,
      logoHaloEffectB: logoDefaultStyle.logoHaloEffect_b,
      logoHaloEffectC: logoDefaultStyle.logoHaloEffect_c,
      logoHaloEffectColor: logoDefaultStyle.logoHaloEffect,
      logoHaloEffect: Boolean(logoDefaultStyle.logoHaloEffect),
    };

    if (iTag.style.textShadow === "unset" && iTag.dataset.boxShadow) {
      const colorSplit = iTag.dataset.boxShadow.split(/\s+/);
      haloEffect.logoHaloEffectX = splitPx(colorSplit[0])[0];
      haloEffect.logoHaloEffectY = splitPx(colorSplit[1])[0];
      haloEffect.logoHaloEffectB = splitPx(colorSplit[2])[0];
      haloEffect.logoHaloEffectC = splitPx(colorSplit[2])[0];
      haloEffect.logoHaloEffectColor = colorSplit[3];
      haloEffect.logoHaloEffect = false;
    } else {
      let splitArray;
      if (iTag.style.textShadow === "unset") {
        const regex = /rgb\(\s*\d+\s*,\s*\d+\s*,\s*\d+\s*\)|-?\d*\.?\d+px/g;
        splitArray = iTag.style.filter.match(regex);
      } else {
        const regex = /rgb\(\d{1,3}, \d{1,3}, \d{1,3}\)|-?\d*\.?\d+px/g;
        splitArray = iTag.style.textShadow.match(regex);
      }
      if (splitArray) {
        haloEffect.logoHaloEffectColor = getHexFromTextShadow(
          splitArray[0],
          "color"
        );
        haloEffect.logoHaloEffectX = splitPx(splitArray[1])[0];
        haloEffect.logoHaloEffectY = splitPx(splitArray[2])[0];
        haloEffect.logoHaloEffectB = splitPx(splitArray[3])[0];
        haloEffect.logoHaloEffectC = splitPx(splitArray[3])[0];
      }
      haloEffect.logoHaloEffect = true;
    }
    if (
      iTag.style &&
      iTag.style.color &&
      iTag.style.color !== "" &&
      iTag.style.color !== "transparent"
    ) {
      backGroundColor = rgbToHex(iTag.style.color);
      isBackGroundColorTransparent = false;
    }

    setSelectedLogo(() => ({
      id: iTag.id,
      connectedLeaderLineId: iTag.dataset.lineConnected,
      openSetting: true,
      resetLogoSettings: true,
      polyLineColor:
        feature && feature.properties["line-color"]
          ? feature.properties["line-color"]
          : logoDefaultStyle.logoLeaderLineColor,
      polyLineWidth:
        feature && feature.properties["line-width"]
          ? feature.properties["line-width"]
          : logoDefaultStyle.logoLeaderLineBorderWidth,
      imageBackgroundColor: backGroundColor,
      isBackgroundColorTransparent: isBackGroundColorTransparent,
      image: iTag.innerHTML,
      logoHaloEffect: haloEffect.logoHaloEffectColor,
      logoHaloEffect_x: haloEffect.logoHaloEffectX,
      logoHaloEffect_y: haloEffect.logoHaloEffectY,
      logoHaloEffect_b: haloEffect.logoHaloEffectB,
      logoHaloEffect_c: haloEffect.logoHaloEffectB,
      isHaloEffectTransparent: haloEffect.logoHaloEffect,
      isLeaderLineEnabled: leaderLineEnabled,
      isLeaderLineDisabled: !isLeaderLineDisabled,
      width: "auto",
      height: "auto",
      lat: "",
      lng: "",
    }));
  };

  static AddEmojiToMap = async ({
    mapboxgl,
    map,
    mapDraw,
    coordinates,
    logo,
    lastClickButton,
    logoDefaultStyle,
    defaultLogoValue,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    setResetMap,
    createNewPolygon,
    updateAutoSave,
    resetAllOnceChanged,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    disableUserActions,
    markerRef,
  }) => {
    const inputMarkerId =
      "emoji^" +
      String(coordinates.lng) +
      "^" +
      String(coordinates.lat) +
      "^" +
      logo;
    // Div element
    const divElement = document.createElement("div");
    divElement.dataset.emoji = "true";
    divElement.id = inputMarkerId;
    const poiSettingLive = getCurrentPoiSetting();

    divElement.style.width = "auto";
    // Sub div element
    const divSubContainerElement = document.createElement("div");
    divSubContainerElement.style.minWidth = "100%";
    divSubContainerElement.style.minHeight = "100%";
    divSubContainerElement.id = inputMarkerId;
    // Sub div element
    const divSubElement = document.createElement("div");
    divSubElement.classList.add("logo-grid-item");
    divSubElement.id = inputMarkerId;

    // Adding box style
    const haloEffectX = logoDefaultStyle.logoHaloEffect_x;
    const haloEffectY = logoDefaultStyle.logoHaloEffect_y;
    const haloEffectB = logoDefaultStyle.logoHaloEffect_b;
    const logoHaloEffect = logoDefaultStyle.logoHaloEffect;
    const leaderLineColor = logoDefaultStyle.logoLeaderLineColor;
    const leaderLineWidth = logoDefaultStyle.logoLeaderLineBorderWidth;

    const iTag = document.createElement("i");
    iTag.id = inputMarkerId;
    iTag.dataset.type = "logo";
    // iTag.style.resize = "both";
    iTag.style.objectFit = "contain";
    iTag.style.fontSize = "50px";
    iTag.style.opacity = "100%";
    iTag.className = logo;
    iTag.dataset.isBackgroundFill = "false";
    iTag.dataset.isBorderFill = "true";
    iTag.dataset.color = hexToRgba(logoDefaultStyle.logoBackgroundColor, 100);

    iTag.style.textShadow = `${haloEffectX}px ${haloEffectY}px ${haloEffectB}px ${logoHaloEffect}`;
    if (logoDefaultStyle.isBackgroundColorTransparent) {
      iTag.style.color = "transparent";
    } else {
      iTag.style.color = hexToRgba(logoDefaultStyle.logoBackgroundColor, 100);
    }

    iTag.dataset.backgroundColor = logoDefaultStyle.logoBackgroundColor;
    iTag.dataset.leaderLineColor = logoDefaultStyle.logoLeaderLineColor;
    iTag.dataset.isBackgroundTransparent =
      logoDefaultStyle.isBackgroundColorTransparent ? "true" : "false";

    iTag.dataset.leaderLineWidth = String(
      logoDefaultStyle.logoLeaderLineBorderWidth
    );
    iTag.dataset.logoHaloEffect_x = String(logoDefaultStyle.logoHaloEffect_x);
    iTag.dataset.logoHaloEffect_y = String(logoDefaultStyle.logoHaloEffect_y);
    iTag.dataset.logoHaloEffect_b = String(logoDefaultStyle.logoHaloEffect_b);
    iTag.dataset.logoHaloEffect = logoDefaultStyle.logoHaloEffect;
    iTag.dataset.connectedLeaderLineWidth =
      logoDefaultStyle.logoLeaderLineColor;
    iTag.dataset.connectedLeaderLineColor = String(
      logoDefaultStyle.logoLeaderLineBorderWidth
    );
    iTag.dataset.lineConnected = inputMarkerId;

    divSubElement.appendChild(iTag);
    divSubContainerElement.appendChild(divSubElement);
    divElement.appendChild(divSubContainerElement);

    const imageMarker = new mapboxgl.Marker({
      draggable: true,
      element: divElement,
      anchor: "top-left",
    })
      .setLngLat([coordinates.lng, coordinates.lat])
      .addTo(map);
    createNewPolygon();
    await new Promise((resolve) => setTimeout(() => resolve(), 100));
    mapDraw = mapDraw.current || mapDraw;
    const lngLat = imageMarker.getLngLat();
    const feature = {
      id: inputMarkerId,
      type: "Feature",
      properties: {
        "line-color": logoDefaultStyle.logoLeaderLineColor,
        "line-width": logoDefaultStyle.logoLeaderLineBorderWidth,
      },
      geometry: {
        type: "LineString",
        coordinates: [
          [lngLat.lng, lngLat.lat],
          [lngLat.lng, lngLat.lat],
        ],
      },
    };

    const featureIds = mapDraw.add(feature);
    mapDraw.changeMode("draw_line_string");
    currentMode.current = "direct_select";
    mapDraw.changeMode("simple_select");

    mapDraw.setFeatureProperty(featureIds[0], "line-color", leaderLineColor);
    mapDraw.setFeatureProperty(
      featureIds[0],
      "line-width",
      leaderLineWidth * 1
    );
    mapDraw.setFeatureProperty(featureIds[0], "vertexColor", leaderLineColor);

    CommonUtils.UpdateVertexColorLayer({
      featureId: featureIds[0],
      mapDraw,
      map,
      currentMode,
      polygonDefaultStyle,
    });
    function onDocumentMouseUp() {
      map.setLayoutProperty(
        featureIds[0] + "-end-point",
        "visibility",
        "visible"
      );
      document.removeEventListener("mouseup", onDocumentMouseUp);
    }
    map.on("mousedown", featureIds[0] + "-end-point", function () {
      map.setLayoutProperty(featureIds[0] + "-end-point", "visibility", "none");
      document.addEventListener("mouseup", onDocumentMouseUp);
    });

    map.on("draw.update", (e) => {
      const features = e.features;
      let updatedCoordinate;
      features.forEach((feature) => {
        if (
          feature.geometry.type === "LineString" &&
          feature.id === featureIds[0]
        ) {
          const coordinates = feature.geometry.coordinates;
          updatedCoordinate = coordinates[0];
          map.getSource(featureIds[0] + "-end-point").setData({
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: updatedCoordinate,
                },
              },
            ],
          });
        }
      });
    });

    map.getCanvas().style.cursor = "default";

    setMapToolBarOptionFlags((prev) => ({
      ...prev,
      logoUpload: false,
    }));
    setResetMap(false);

    setSelectedLogo({
      ...defaultLogoValue.current,
      openSetting: true,
      id: inputMarkerId,
      connectedLeaderLineId: iTag.dataset.lineConnected,
      polyLineColor: logoDefaultStyle.logoLeaderLineColor,
      polyLineWidth: logoDefaultStyle.logoLeaderLineBorderWidth,
      imageBackgroundColor: logoDefaultStyle.logoBackgroundColor,
      logoHaloEffect: logoDefaultStyle.logoHaloEffect,
      image: logo,
      isBackgroundColorTransparent:
        logoDefaultStyle.isBackgroundColorTransparent,
      isLeaderLineEnabled: false,
    });

    markerRef.current.push({
      id: inputMarkerId,
      marker: imageMarker,
      type: "logo",
    });
    updateAutoSave();

    iTag.addEventListener("contextmenu", (event) => {
      event.preventDefault();
      if (disableUserActions?.()) {
        return;
      }
      currentMode.current = "direct_select";
      lastClickButton.current = 0;
      resetAllOnceChanged();
      this.GetEmojiStyleWithLeaderLine({
        mapDraw,
        imageMarker,
        iTag,
        logoDefaultStyle,
        setSelectedLogo,
      });
    });

    iTag.dataset.leaderLineEnabled = "false";

    const lineConnected = CommonUtils.HideOrShowLeaderLine({
      mapDraw,
      connectedLeaderLine: inputMarkerId,
      correspondingElement: iTag,
      leaderLine: {
        leaderLineColor: poiSettingLive.poiLeaderLineColor,
        leaderLineWidth: poiSettingLive.poiLeaderLineBorderWidth,
      },
      condition: true,
      map,
    });
    iTag.dataset.leaderLine = JSON.stringify(lineConnected);

    this.AddLogoEventListener({
      map,
      mapDraw,
      mapboxgl,
      imageMarker,
      logoElement: iTag,
      connectedLeaderLineId: iTag.dataset.lineConnected,
      logoDefaultStyle,
      lastClickButton,
      defaultLogoValue,
      poiSetting: poiSettingLive,
      setSelectedLogo,
      setMapToolBarOptionFlags,
      updateAutoSave,
      setResetMap,
      createNewPolygon,
      resetAllOnceChanged,
      currentMode,
      polygonDefaultStyle,
      getCurrentPoiSetting,
      setDrawnFeaturesSupport,
      setUndoHistory,
      setRedoHistory,
      disableUserActions,
      isEmoji: true,
      markerRef,
    });
  };

  static ChangeLogoDesign = ({
    mapDraw,
    map,
    id,
    connectedLeaderLineId,
    backgroundColor,
    logoHaloEffect,
    logoHaloEffect_x,
    logoHaloEffect_y,
    logoHaloEffect_b,
    logoHaloEffect_c,
    isHaloEffectTransparent,
    lineColor,
    width,
    isLeaderLineEnabled,
    logoDefaultStyle,
    updateAutoSave,
    setSelectedLogo,
    currentMode,
    polygonDefaultStyle,
    divWidth,
    height,
    lat,
    lng,
    setUndoHistory,
    setRedoHistory,
    setDrawnFeaturesSupport,
    checkUpdate,
    markers,
    allCoordinates,
  }) => {
    updateAutoSave();
    let image = null;
    const currentMarker = markers.find(
      (marker) =>
        marker.id === id || (marker.idList && marker.idList.includes(id))
    );
    if (currentMarker) {
      const markerDivElement = currentMarker.marker.getElement();
      const logoElements = markerDivElement.querySelectorAll("div");
      const clusterValue = markerDivElement.getAttribute("data-cluster");
      if (!clusterValue) {
        markerDivElement.style.width = divWidth;
      }
      let allowImage = true;
      logoElements.forEach((element) => {
        if (element && element.id === id) {
          const img = element.querySelector("img");
          const iTag = element.querySelector("i");
          if (img) {
            image = img;
            if (image && allowImage) {
              allowImage = false;
              image.style.backgroundColor = backgroundColor;
              image.dataset.modified = "true";
              if (isLeaderLineEnabled) {
                image.dataset.leaderLineEnabled = "true";
              } else {
                image.dataset.leaderLineEnabled = "false";
              }
              if (backgroundColor !== "transparent") {
                image.dataset.backgroundColor = backgroundColor;
              }
              image.dataset.isBackgroundTransparent =
                backgroundColor === "transparent" ? "true" : "false";
              if (
                backgroundColor === "transparent" &&
                isHaloEffectTransparent
              ) {
                image.style.filter = `drop-shadow(${logoHaloEffect_x}px ${logoHaloEffect_y}px ${logoHaloEffect_b}px ${logoHaloEffect})`;
                image.style.boxShadow = "unset";
              } else if (isHaloEffectTransparent) {
                image.style.boxShadow = `${logoHaloEffect_x}px ${logoHaloEffect_y}px ${logoHaloEffect_b}px ${logoHaloEffect}`;
                image.style.filter = "unset";
              } else {
                image.style.boxShadow = "unset";
                image.style.filter = "unset";
                image.dataset.boxShadow = `${logoHaloEffect_x}px ${logoHaloEffect_y}px ${logoHaloEffect_b}px ${logoHaloEffect}`;
              }
              if (!isHaloEffectTransparent) {
                image.dataset.logoHaloEffect = logoHaloEffect;
                image.style.filter = this.LogoBorderStyle;
              }
              if (!checkUpdate) {
                image.dataset.lat = lat;
                image.dataset.lng = lng;
              }

              // Please uncomment the code when you are using leader line for the logo.
              const feature = CommonUtils.HideOrShowLeaderLine({
                mapDraw,
                connectedLeaderLine: connectedLeaderLineId,
                correspondingElement: image,
                leaderLine: {
                  leaderLineColor: logoDefaultStyle.logoLeaderLineColor,
                  leaderLineWidth: logoDefaultStyle.logoLeaderLineBorderWidth,
                },
                condition: !isLeaderLineEnabled,
                map,
              });
              currentMode.current = "direct_select";
              if (feature) {
                image.dataset.connectedLeaderLineWidth = String(width);
                image.dataset.connectedLeaderLineColor = lineColor;
                feature.properties.vertexColor = lineColor;
                feature.properties["line-color"] = lineColor;
                if (width > 0) feature.properties["line-width"] = width * 1;
                image.dataset.leaderLine = JSON.stringify(feature);
                const vertexPoint = map.getLayer(feature.id + "-end-point");
                if (vertexPoint) {
                  map.setPaintProperty(
                    vertexPoint.id,
                    "circle-color",
                    lineColor
                  );
                }
                if (isLeaderLineEnabled) {
                  mapDraw.add(feature);
                  if (width > 0) {
                    mapDraw.setFeatureProperty(
                      connectedLeaderLineId,
                      "line-width",
                      width * 1
                    );
                  }
                  mapDraw.setFeatureProperty(
                    connectedLeaderLineId,
                    "line-color",
                    lineColor
                  );
                  CommonUtils.UpdateVertexColorLayer({
                    featureId: connectedLeaderLineId,
                    mapDraw,
                    map,
                    currentMode,
                    polygonDefaultStyle,
                  });
                }
              }

              setSelectedLogo((previousValue) => {
                if (previousValue) {
                  return {
                    ...previousValue,
                    polyLineColor: lineColor,
                    polyLineWidth: width,
                    imageBackgroundColor:
                      backgroundColor === "transparent"
                        ? String(image.dataset.backgroundColor)
                        : backgroundColor,
                    logoHaloEffect: logoHaloEffect,
                    logoHaloEffect_x: logoHaloEffect_x,
                    logoHaloEffect_y: logoHaloEffect_y,
                    logoHaloEffect_b: logoHaloEffect_b,
                    logoHaloEffect_c: logoHaloEffect_c,
                    isHaloEffectTransparent: isHaloEffectTransparent,
                    isBackgroundColorTransparent:
                      backgroundColor === "transparent",
                    isLeaderLineEnabled: isLeaderLineEnabled,
                    resetLogoSettings: true,
                  };
                }
                return null;
              });
              const clusterValue =
                markerDivElement.getAttribute("data-cluster");
              if (markers && !checkUpdate) {
                const selectedMarker = markers.filter(
                  (item) => item.id === id
                )[0];
                selectedMarker.marker.setLngLat([+lng, +lat]);
                this.OnMoveLogo({
                  coordinates: { lng: +lng, lat: +lat },
                  connectedLeaderLine: connectedLeaderLineId,
                  mapDraw,
                  connectedLeaderLineWidth:
                    logoDefaultStyle.logoLeaderLineBorderWidth,
                  imageElement: image,
                  logoDefaultStyle,
                  map,
                  isUpdate: true,
                  allCoordinates,
                });
                if (isLeaderLineEnabled) {
                  const parsedLeaderLine = JSON.parse(image.dataset.leaderLine);
                  const featureIds = mapDraw.add(parsedLeaderLine);
                  const currentCoordinates =
                    parsedLeaderLine.geometry.coordinates[0];
                  const lineConnected = mapDraw.get(connectedLeaderLineId);
                  parsedLeaderLine.properties["line-width"] = width * 1;
                  let updatedCoordinate;
                  if (parsedLeaderLine.geometry.type === "LineString") {
                    const coordinates = parsedLeaderLine.geometry.coordinates;
                    updatedCoordinate = coordinates[0];
                    map.getSource(featureIds[0] + "-end-point")?.setData({
                      type: "FeatureCollection",
                      features: [
                        {
                          type: "Feature",
                          geometry: {
                            type: "Point",
                            coordinates: updatedCoordinate,
                          },
                        },
                      ],
                    });
                  }
                  // initial latlng end point hide process for undo redo
                  if (
                    currentCoordinates &&
                    +currentCoordinates[0] === +image.dataset.lng &&
                    +currentCoordinates[1] === +image.dataset.lat &&
                    lineConnected
                  ) {
                    map.removeLayer(lineConnected.id + "-end-point");
                    map.removeSource(lineConnected.id + "-end-point");
                  }
                }
              }
              if (checkUpdate && !clusterValue) {
                this.updatePreviousValueChange({
                  action: "update",
                  setDrawnFeaturesSupport,
                  inputMarkerId: id,
                  image,
                  setSelectedLogo,
                  setUndoHistory,
                  setRedoHistory,
                });
              }
            }
          }
          if (iTag) {
            iTag.style.color = backgroundColor;
            iTag.dataset.modified = "true";
            if (isLeaderLineEnabled) {
              iTag.dataset.leaderLineEnabled = "true";
            } else {
              iTag.dataset.leaderLineEnabled = "false";
            }
            if (backgroundColor !== "transparent") {
              iTag.dataset.backgroundColor = backgroundColor;
            }
            iTag.dataset.isBackgroundTransparent =
              backgroundColor === "transparent" ? "true" : "false";
            if (isHaloEffectTransparent) {
              iTag.style.textShadow = `${logoHaloEffect_x}px ${logoHaloEffect_y}px ${logoHaloEffect_b}px ${logoHaloEffect}`;
              iTag.dataset.boxShadow = `${logoHaloEffect_x}px ${logoHaloEffect_y}px ${logoHaloEffect_b}px ${logoHaloEffect}`;
              iTag.dataset.logoHaloEffect = logoHaloEffect;
            } else {
              iTag.style.textShadow = "unset";
            }
            const feature = CommonUtils.HideOrShowLeaderLine({
              mapDraw,
              connectedLeaderLine: connectedLeaderLineId,
              correspondingElement: iTag,
              leaderLine: {
                leaderLineColor: logoDefaultStyle.logoLeaderLineColor,
                leaderLineWidth: logoDefaultStyle.logoLeaderLineBorderWidth,
              },
              condition: !isLeaderLineEnabled,
              map,
            });
            currentMode.current = "direct_select";
            if (feature) {
              iTag.dataset.connectedLeaderLineWidth = String(width);
              iTag.dataset.connectedLeaderLineColor = lineColor;
              feature.properties.vertexColor = lineColor;
              feature.properties["line-color"] = lineColor;
              if (width > 0) feature.properties["line-width"] = width * 1;
              iTag.dataset.leaderLine = JSON.stringify(feature);
              const vertexPoint = map.getLayer(feature.id + "-end-point");
              if (vertexPoint) {
                map.setPaintProperty(vertexPoint.id, "circle-color", lineColor);
              }
              if (isLeaderLineEnabled) {
                mapDraw.add(feature);
                if (width > 0) {
                  mapDraw.setFeatureProperty(
                    connectedLeaderLineId,
                    "line-width",
                    width * 1
                  );
                }
                mapDraw.setFeatureProperty(
                  connectedLeaderLineId,
                  "line-color",
                  lineColor
                );
                CommonUtils.UpdateVertexColorLayer({
                  featureId: connectedLeaderLineId,
                  mapDraw,
                  map,
                  currentMode,
                  polygonDefaultStyle,
                });
              }
            }

            setSelectedLogo((previousValue) => {
              if (previousValue) {
                return {
                  ...previousValue,
                  polyLineColor: lineColor,
                  polyLineWidth: width,
                  imageBackgroundColor: backgroundColor,
                  logoHaloEffect: logoHaloEffect,
                  logoHaloEffect_x: logoHaloEffect_x,
                  logoHaloEffect_y: logoHaloEffect_y,
                  logoHaloEffect_b: logoHaloEffect_b,
                  logoHaloEffect_c: logoHaloEffect_c,
                  isHaloEffectTransparent: isHaloEffectTransparent,
                  isLeaderLineEnabled: isLeaderLineEnabled,
                };
              }
              return null;
            });
          }
        }
      });
    }
  };

  static DeleteMarker = ({
    imageId,
    POICategoryList,
    map,
    mapDraw,
    mapboxgl,
    setPOICategoryList,
    lastClickButton,
    logoDefaultStyle,
    defaultLogoValue,
    poiSetting,
    setSelectedLogo,
    setMapToolBarOptionFlags,
    setResetMap,
    createNewPolygon,
    updateAutoSave,
    resetAllOnceChanged,
    currentMode,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    markerRef,
  }) => {
    mapDraw.delete(imageId);
    const selectedPoiRetailerId = Object.keys(
      POICategoryList.selectedPOIRetailerNameList
    );
    const changedMarkers = markerRef.current.filter((marker) => {
      let returnCondition = true;
      const markerId = marker.id.split("^");
      if (marker.id === imageId) {
        marker.marker.remove();
        mapDraw.delete(imageId);
        const vertexPoint = map.getLayer(marker.id + "-end-point");
        if (vertexPoint) {
          map.removeLayer(marker.id + "-end-point");
          map.removeSource(marker.id + "-end-point");
        }
        CustomPOIClass.RemoveElementFromObjectArray({
          keyToRemove: markerId[3],
          valueToRemove: imageId,
          setPOICategoryList,
        });
        returnCondition = false;
        if (marker.idList) {
          marker.idList = marker.idList.filter(
            (markerId) => markerId !== marker.id
          );
          marker.idList.forEach((subLogoElement) => {
            const subMarkerId = subLogoElement.split("^");
            let imageSrc = subMarkerId[3];
            let isPoi = null;
            if (
              subLogoElement.startsWith("poiImage^") &&
              selectedPoiRetailerId.includes(subMarkerId[3])
            ) {
              imageSrc = CustomPOIClass.GetPoiImageUrl(subMarkerId[3]);
              isPoi = subLogoElement;
            }
            this.AddLogoToMap({
              mapboxgl,
              map,
              mapDraw,
              coordinates: {
                lat: parseFloat(subMarkerId[2]),
                lng: parseFloat(subMarkerId[1]),
              },
              logo: imageSrc,
              lastClickButton,
              logoDefaultStyle,
              defaultLogoValue,
              setSelectedLogo,
              setMapToolBarOptionFlags,
              setResetMap,
              createNewPolygon,
              updateAutoSave,
              resetAllOnceChanged,
              poiImageId: isPoi,
              currentMode,
              polygonDefaultStyle,
              getCurrentPoiSetting,
              setDrawnFeaturesSupport,
              setUndoHistory,
              setRedoHistory,
              markerRef,
            });
          });
        }
        return returnCondition;
      }
      if (marker.idList && marker.idList.includes(imageId)) {
        const markerElement = marker.marker.getElement();
        const subDivElement = markerElement.querySelector("div");
        const logoElementToBeAppend = subDivElement.querySelectorAll("div");
        const changedMapList = marker.idList.filter((subLogoElement) => {
          if (subLogoElement === imageId) {
            logoElementToBeAppend.forEach((iteratorElement) => {
              if (iteratorElement.id === imageId) {
                const iteratorElementId = iteratorElement.id.split("^");
                CustomPOIClass.RemoveElementFromObjectArray({
                  keyToRemove: iteratorElementId[3],
                  valueToRemove: iteratorElement.id,
                  setPOICategoryList,
                });
                iteratorElement.remove();
              }
            });
            return false;
          }
          return true;
        });
        marker.idList = changedMapList;

        if (marker.idList.length === 1) {
          const clonedMarkerDiv = marker.marker.getElement();
          const clonedSubDivElement = clonedMarkerDiv
            .querySelector("div")
            .cloneNode(true);
          const clonedSubDivSpan = clonedMarkerDiv.querySelector("span");
          clonedSubDivSpan.remove();
          const SubDivElement = clonedMarkerDiv.querySelector("div");
          SubDivElement.remove();

          const clonedSubDivContainer =
            clonedSubDivElement.querySelector("div");
          const logoImg = clonedSubDivElement.querySelector("img");

          clonedMarkerDiv.dataset.cluster = "false";
          clonedMarkerDiv.style.width = poiSetting.poiWidthAndHeight;
          clonedMarkerDiv.style.height = "auto";
          clonedSubDivElement.className = "";
          clonedSubDivElement.style.width = "unset";
          clonedSubDivElement.style.height = "unset";
          clonedSubDivContainer.style.width = "100%";
          clonedSubDivContainer.style.height = "100%";
          clonedMarkerDiv.appendChild(clonedSubDivElement);

          logoImg.addEventListener("contextmenu", (event) => {
            //if (disableUserActions()) return;
            event.preventDefault();
            lastClickButton.current = 0;
            resetAllOnceChanged();
            this.GetLogoStyleWithLeaderLine({
              mapDraw,
              imageMarker: marker.marker,
              logoElement: logoImg,
              logoDefaultStyle,
              setSelectedLogo,
            });
          });

          this.AddLogoEventListener({
            map,
            mapDraw,
            mapboxgl,
            imageMarker: marker.marker,
            logoElement: logoImg,
            connectedLeaderLineId: logoImg.id,
            logoDefaultStyle,
            lastClickButton,
            defaultLogoValue,
            poiSetting,
            setSelectedLogo,
            setMapToolBarOptionFlags,
            updateAutoSave,
            setResetMap,
            createNewPolygon,
            resetAllOnceChanged,
            currentMode,
            polygonDefaultStyle,
            getCurrentPoiSetting,
            setDrawnFeaturesSupport,
            setUndoHistory,
            setRedoHistory,
            markerRef,
          });
        }

        return marker;
      }
      return true;
    });
    markerRef.current = changedMarkers;

    updateAutoSave();
  };

  static RecoverEmojiFromMapData = ({
    coordinates,
    logoElement,
    mapboxgl,
    map,
    mapDraw,
    lastClickButton,
    logoDefaultStyle,
    resetAllOnceChanged,
    setSelectedLogo,
    updateAutoSave,
    setMapToolBarOptionFlags,
    setResetMap,
    createNewPolygon,
    currentMode,
    defaultLogoValue,
    poiSetting,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    disableUserActions,
    markerRef,
  }) => {
    const inputMarkerId = logoElement.id;

    const imageMarker = new mapboxgl.Marker({
      draggable: true,
      element: logoElement,
      anchor: "top-left",
    })
      .setLngLat([coordinates.lng, coordinates.lat])
      .addTo(map);
    const logoElementLocal = imageMarker.getElement();
    const subLogoContainer = logoElement.querySelector("div");
    const subLogoItems = subLogoContainer.querySelectorAll("div");
    const logoElementImage = subLogoItems[0].querySelector("i");
    mapDraw = mapDraw.current || mapDraw;
    this.AddLogoEventListener({
      map,
      mapDraw,
      mapboxgl,
      imageMarker,
      logoElement: logoElementImage,
      connectedLeaderLineId: logoElementImage.id,
      logoDefaultStyle,
      lastClickButton,
      defaultLogoValue,
      poiSetting,
      setSelectedLogo,
      setMapToolBarOptionFlags,
      updateAutoSave,
      setResetMap,
      createNewPolygon,
      resetAllOnceChanged,
      currentMode,
      polygonDefaultStyle,
      getCurrentPoiSetting,
      setDrawnFeaturesSupport,
      setUndoHistory,
      setRedoHistory,
      disableUserActions,
      isEmoji: true,
      markerRef,
    });
    const markerImagesId = [];

    logoElementLocal.addEventListener("contextmenu", (event) => {
      if (disableUserActions()) return;
      event.preventDefault();
      lastClickButton.current = 0;
      resetAllOnceChanged();
      this.GetEmojiStyleWithLeaderLine({
        mapDraw,
        imageMarker,
        iTag: logoElementImage,
        logoDefaultStyle,
        setSelectedLogo,
      });
    });
    markerRef.current.push({
      id: inputMarkerId,
      marker: imageMarker,
      type: "logo",
      idList: markerImagesId,
    });

    map.on("draw.update", (e) => {
      const features = e.features;
      let updatedCoordinate;
      features.forEach((feature) => {
        if (
          feature.geometry.type === "LineString" &&
          feature.id === inputMarkerId
        ) {
          const coordinates = feature.geometry.coordinates;
          updatedCoordinate = coordinates[0];
          map.getSource(inputMarkerId + "-end-point").setData({
            type: "FeatureCollection",
            features: [
              {
                type: "Feature",
                geometry: {
                  type: "Point",
                  coordinates: updatedCoordinate,
                },
              },
            ],
          });
        }
      });
    });

    updateAutoSave();
  };

  static RecoverLogoFromMapData = ({
    coordinates,
    logoElement,
    mapboxgl,
    map,
    mapDraw,
    lastClickButton,
    logoDefaultStyle,
    resetAllOnceChanged,
    setSelectedLogo,
    updateAutoSave,
    setMapToolBarOptionFlags,
    setResetMap,
    createNewPolygon,
    currentMode,
    defaultLogoValue,
    poiSetting,
    polygonDefaultStyle,
    getCurrentPoiSetting,
    disableUserActions,
    setDrawnFeaturesSupport,
    setUndoHistory,
    setRedoHistory,
    markerRef,
  }) => {
    const inputMarkerId = logoElement.id;

    const imageMarker = new mapboxgl.Marker({
      draggable: true,
      element: logoElement,
      anchor: "top-left",
    })
      .setLngLat([coordinates.lng, coordinates.lat])
      .addTo(map);
    const logoElementLocal = imageMarker.getElement();
    const subLogoContainer = logoElement.querySelector("div");
    const subLogoItems = subLogoContainer.querySelectorAll("div");
    const clusterInteractionElements = logoElementLocal.querySelectorAll("i");
    const logoElementImage = subLogoItems[0].querySelector("img");
    mapDraw = mapDraw.current || mapDraw;
    this.AddLogoEventListener({
      map,
      mapDraw,
      mapboxgl,
      imageMarker,
      logoElement: logoElementImage,
      connectedLeaderLineId: logoElementImage.id,
      logoDefaultStyle,
      lastClickButton,
      defaultLogoValue,
      poiSetting,
      setSelectedLogo,
      setMapToolBarOptionFlags,
      updateAutoSave,
      setResetMap,
      createNewPolygon,
      resetAllOnceChanged,
      currentMode,
      polygonDefaultStyle,
      getCurrentPoiSetting,
      setDrawnFeaturesSupport,
      setUndoHistory,
      setRedoHistory,
      disableUserActions,
      markerRef,
    });
    const markerImagesId = [];
    // if (subLogoItems && subLogoItems.length > 1) {
    //   subLogoItems.forEach((element) => {
    //     if (element && element.classList.contains("logo-grid-item")) {
    //       markerImagesId.push(element.id);
    //       this.AddClusterLogoEventListener({
    //         currenMarker: imageMarker,
    //         subElement: element,
    //         map,
    //         mapDraw,
    //         mapboxgl,
    //         logoDefaultStyle,
    //         lastClickButton,
    //         defaultLogoValue,
    //         poiSetting,
    //         setSelectedLogo,
    //         setMapToolBarOptionFlags,
    //         updateAutoSave,
    //         setResetMap,
    //         createNewPolygon,
    //         resetAllOnceChanged,
    //         currentMode,
    //         polygonDefaultStyle,
    //         getCurrentPoiSetting,
    //         setDrawnFeaturesSupport,
    //         setUndoHistory,
    //         setRedoHistory,
    //         markerRef,
    //         disableUserActions,
    //       });
    //     }
    //   });
    //   if (clusterInteractionElements && clusterInteractionElements.length > 0) {
    //     clusterInteractionElements.forEach((element) => {
    //       if (element && element.id === "remove-cluster") {
    //         element.addEventListener("mousedown", function () {
    //           CustomLogoClass.ClusterOutAllImagesInside({
    //             marker: imageMarker,
    //             map,
    //             mapDraw,
    //             mapboxgl,
    //             logoDefaultStyle,
    //             lastClickButton,
    //             defaultLogoValue,
    //             poiSetting,
    //             setSelectedLogo,
    //             setMapToolBarOptionFlags,
    //             updateAutoSave,
    //             setResetMap,
    //             createNewPolygon,
    //             resetAllOnceChanged,
    //             currentMode,
    //             polygonDefaultStyle,
    //             getCurrentPoiSetting,
    //             setDrawnFeaturesSupport,
    //             setUndoHistory,
    //             setRedoHistory,
    //             markerRef,
    //           });
    //         });
    //       }
    //     });
    //   }
    // } else 
    if (subLogoItems && subLogoItems.length === 1) {
      logoElementLocal.addEventListener("contextmenu", (event) => {
        if (disableUserActions()) return;
        event.preventDefault();
        lastClickButton.current = 0;
        resetAllOnceChanged();
        this.GetLogoStyleWithLeaderLine({
          mapDraw,
          imageMarker,
          logoElement: logoElementImage,
          logoDefaultStyle,
          setSelectedLogo,
        });
      });
    }
    markerRef.current.push({
      id: inputMarkerId,
      marker: imageMarker,
      type: "logo",
      idList: markerImagesId,
    });
    setDrawnFeaturesSupport((previousValue) => {
      previousValue[logoElementImage.id] = logoElementImage.cloneNode();
      return previousValue;
    });
    updateAutoSave();
  };
}
